import React from "react";
import {Collection} from "./base/Collection";
import {Model} from "./base/Model";

import { CompanyModel } from "./PPC/Company";

export const MODEL = {
    COMPANY : "CompanyModel"
}


import PaginationModel from "./PPC/Base/PaginationModel"; 
import { CustomerModel } from "./Customer";

class DB {
    newCollection(data:any, modelInstance = null) {
        let collection = new Collection(data, modelInstance);
        return collection;
    }    
    
    newModel(data:Model | Object | null, modelInstance = null) {
        let model = null;
        console.debug("typeof modelInstance", modelInstance);
        console.debug("typeof modelInstance", typeof modelInstance);
        if(typeof modelInstance == 'string' && modelInstance != "") {
            let classNameString = modelInstance;
            console.debug("INIT!! "+classNameString, data);
            model = this.getModelByName(classNameString, data);
            console.debug("get model by name after ",model);
            return model;
            console.debug("new " + classNameString + "()");
            let returnModel:any = null;
            eval("returnModel =  new " + classNameString + "()");
            return returnModel;
            return new PaginationModel(data);
            console.debug("modelInstance", modelInstance); 
            
        }
        
        if(!model && modelInstance) {
                model = new modelInstance(data);
//            if(data instanceof Object) {
//                model.createModel(data);
//            }
            //model.create
        } else {
            model = new Model(data);
//            if(data instanceof Object) {
//                model.createModel(data);
//            }
        }
        return model;
    }    
    
    getModelByName = (name, data) => {
        console.debug(name);
        console.debug(data);
        if(name == "PaginationModel") {
                console.debug("get model by name",name);

                return new PaginationModel(data);
        } else
        if(name == "CustomerModel") {
                return new CustomerModel(data);
        }
    }


}

export default new DB();  